import { useState, useCallback } from 'react';
import { playbookApi } from '../api/playbookApi';
import type { PlaybookScheme, PlaybookTaskType } from '../types/playbook.types';

export function usePlaybookSchemes() {
  const [schemes, setSchemes] = useState<PlaybookScheme[]>([]);
  const [taskTypes, setTaskTypes] = useState<PlaybookTaskType[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadSchemes = useCallback(async (practiceArea?: string) => {
    setLoading(true);
    setError(null);
    try {
      const [sRes, tRes] = await Promise.allSettled([
        playbookApi.listSchemes(practiceArea),
        playbookApi.listTaskTypes({ practice_area: practiceArea }),
      ]);

      if (sRes.status === 'fulfilled') {
        const d = sRes.value as any;
        setSchemes(d.schemes || (Array.isArray(d) ? d : []));
      }
      if (tRes.status === 'fulfilled') {
        const d = tRes.value as any;
        setTaskTypes(d.taskTypes || (Array.isArray(d) ? d : []));
      }
    } catch (err) {
      console.error('[usePlaybookSchemes] Failed:', err);
      setError(err instanceof Error ? err.message : 'Failed to load schemes');
    } finally {
      setLoading(false);
    }
  }, []);

  const createScheme = useCallback(async (data: { name: string; description?: string; practice_area?: string; jurisdiction_code?: string; is_default?: boolean }) => {
    const res = await playbookApi.createScheme(data);
    return res as any as PlaybookScheme;
  }, []);

  const updateMapping = useCallback(async (schemeId: string, taskTypeId: string, playbookId: string) => {
    await playbookApi.addSchemeMapping(schemeId, { task_type_id: taskTypeId, playbook_id: playbookId });
  }, []);

  return { schemes, taskTypes, loading, error, loadSchemes, createScheme, updateMapping };
}
